<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container
    [observables]="[process$, IndirectRateManagementModel$]"
></ef-loading-container>
<ef-loading
    [processing]="showTimer$ | async"
    [processingText]="processingText"
></ef-loading>
<ef-indirect-rate-management-presenter
    (SetProcessingText)="onSetProcessingText($event)"
    [userInfo]="userInfo$ | async"
    [FiscalYears]="fiscalYears$ | async"
    [CurrentFiscalYear]="currentFY$ | async"
    [selectedErrorWithStatus]="selectedErrorWithStatus$ | async"
    (ShowError)="onShowError($event)"
    (FiscalYearSelected)="FiscalYearSelectedSubject.next($event)"
    (Cancel)="CancelSubject.next()"
></ef-indirect-rate-management-presenter>
